import {FC} from 'react';
import {CloseIcon} from 'shared/icons';
import styles from './CloseHeader.module.css';

type Props = {
	onClose: () => void;
};

export const CloseHeader: FC<Props> = ({onClose}) => {
	return (
		<header className={styles.root}>
			<button type="button" className={styles.closeButton} onClick={onClose} aria-label="Закрыть">
				<CloseIcon className={styles.closeIcon} />
			</button>
		</header>
	);
};
